<link rel="stylesheet" href="https://unpkg.com/@progress/kendo-font-icons/dist/index.css" />
<div class="k-overlay" *ngIf="editWinOpen"></div>

<ng-template #windowTitleBar let-win>
  <span class="k-window-title"><span class="k-icon k-font-icon k-icon-xl k-i-form-element">
    </span> {{showTitle}}</span>
  <button kendoWindowCloseAction [window]="win"></button>
</ng-template>


<!--(dashboard === dashboardEnums.ICEBOX || dashboard === dashboardEnums.CURRENT)-->
@if(dashboard === dashboardEnums.ICEBOX || dashboard === dashboardEnums.CURRENT) {
<kendo-grid [kendoGridBinding]="gridData"  [sortable]="false" [groupable]="true" [resizable]="true"
            [filter]="filter" filterable="menu" (filterChange)="filterChange($event)"
            [pageSize]="pageSize" [pageable]="{  buttonCount: buttonCount, pageSizes: pageSizes, previousNext: previousNext}"
            style="height: calc(100vh - 200px); min-height: 400px;">
  <ng-template kendoGridToolbarTemplate position="top">
    <div>
      <h5>
        User Stories
      </h5>
    </div>
    <kendo-grid-spacer></kendo-grid-spacer>
    @if(dashboard === dashboardEnums.CURRENT){
    <button [hidden]="!canCreate" (click)="onAddClicked(windowTitleBar)" kendoButton class="btn btn-primary">
      <fa-icon icon="circle-plus"></fa-icon> Add User Story
    </button>
    }
  </ng-template>

  <kendo-grid-column title="Edit" [width]="70" [style]="vTop">
    <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
      <button (click)="onEditClick(dataItem, windowTitleBar)" [hidden]="!canUpdate" kendoButton
              class="btn btn-stn-grid">
        <fa-icon icon="edit"></fa-icon>
      </button>
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-column title="Order" [width]="70" [style]="vTop" >
    <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">

      <button (click)="move(dataItem, 'up')" kendoButton class="btn btn-stn-grid mb-1" *ngIf="dataItem.previous_id">
        <fa-icon icon="arrow-up"></fa-icon>
      </button>
      <button (click)="move(dataItem, 'down')" kendoButton class="btn btn-stn-grid" *ngIf="dataItem.next_id">
        <fa-icon icon="arrow-down"></fa-icon>
      </button>
    </ng-template>
  </kendo-grid-column>




  <kendo-grid-column title="History" [width]="80" [style]="vTop">
    <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
      <button (click)="onViewHistoryClick(dataItem, windowTitleBar)" kendoButton class="btn btn-stn-grid">
        <fa-icon icon="timeline"></fa-icon>
      </button>
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-column field="id" title="Id" [width]="140" [style]="vTop">
    <ng-template kendoGridCellTemplate let-dataItem>
      <kendo-buttongroup selection="single">
        <button kendoButton title="Copy this story's link to your clipboard" (click)="copyLink(dataItem)">
          <fa-icon class="fa-solid fa-duotone " [icon]="['fad', 'link']"></fa-icon>
        </button>
        <button kendoButton title="Copy this story's ID to your clipboard" (click)="copyStoryID(dataItem.id)">
          {{dataItem.id}}
        </button>
      </kendo-buttongroup>
    </ng-template>
    <ng-template kendoGridFilterMenuTemplate let-column="column" let-filter="filter" let-filterService="filterService">
      <multicheck-filter [isPrimitive]="true" [field]="column.field" [filterService]="filterService"
                         [currentFilter]="filter" [data]="distinctPrimitive(column.field, true)"></multicheck-filter>
    </ng-template>
  </kendo-grid-column>

  <!-- <kendo-grid-column field="project_name" title="Project Name" [width]="160" [style]="vTop">
    <ng-template kendoGridFilterMenuTemplate let-column="column" let-filter="filter" let-filterService="filterService">
      <multicheck-filter [isPrimitive]="true" [field]="column.field" [filterService]="filterService"
        [currentFilter]="filter" [data]="distinctPrimitive(column.field)"></multicheck-filter>
    </ng-template>
  </kendo-grid-column> -->

  <kendo-grid-column field="title" title="Title" [width]="250" [style]="vTop">
    <ng-template kendoGridCellTemplate let-dataItem>
      <div [innerHTML]="formatText(dataItem.title)"></div>
    </ng-template>
    <ng-template kendoGridFilterMenuTemplate let-column="column" let-filter="filter" let-filterService="filterService">
      <multicheck-filter [isPrimitive]="true" [field]="column.field" [filterService]="filterService"
                         [currentFilter]="filter" [data]="distinctPrimitive(column.field)"></multicheck-filter>
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-column field="user_story_priority_description" title="Priority" [width]="120">
    <ng-template kendoGridCellTemplate let-dataItem>
      <div [ngClass]="{'priority-low': dataItem.user_story_priority_description?.toLowerCase().indexOf('low') != -1
        , 'priority-medium': dataItem.user_story_priority_description?.toLowerCase().indexOf('medium') != -1
        , 'priority-high': dataItem.user_story_priority_description?.toLowerCase().indexOf('high') != -1
        , 'priority-critical': dataItem.user_story_priority_description?.toLowerCase().indexOf('critical') != -1 }">
        {{dataItem.user_story_priority_description}}
      </div>
    </ng-template>
    <ng-template kendoGridFilterMenuTemplate let-column="column" let-filter="filter" let-filterService="filterService">
      <multicheck-filter [isPrimitive]="true" [field]="column.field" [filterService]="filterService"
                         [currentFilter]="filter" [data]="distinctPrimitive(column.field)"></multicheck-filter>
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-column field="user_story_status_description" title="Status" [width]="120" [style]="vTop">
    <ng-template kendoGridCellTemplate let-dataItem>
      <span
        [ngStyle]="{'color': dataItem.user_story_status_description?.toLowerCase() == 'accepted' ? 'green' :
        dataItem.user_story_status_description?.toLowerCase() == 'rejected' ? 'red' :
        dataItem.user_story_status_description?.toLowerCase() == 'finished' || dataItem.user_story_status_description?.toLowerCase() == 'delivered' ? 'blue' : ''}">
        {{dataItem.user_story_status_description}}
      </span>
    </ng-template>
    <ng-template kendoGridFilterMenuTemplate let-column="column" let-filter="filter" let-filterService="filterService">
      <multicheck-filter [isPrimitive]="true" [field]="column.field" [filterService]="filterService"
                         [currentFilter]="filter" [data]="distinctPrimitive(column.field)"></multicheck-filter>
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-column field="user_story_type_description" title="Type" [width]="110" [style]="vTop">
    <ng-template kendoGridFilterMenuTemplate let-column="column" let-filter="filter" let-filterService="filterService">
      <multicheck-filter [isPrimitive]="true" [field]="column.field" [filterService]="filterService"
                         [currentFilter]="filter" [data]="distinctPrimitive(column.field)"></multicheck-filter>
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-column field="owned_by_users" title="Owners" [width]="120" [style]="vTop">
    <ng-template kendoGridFilterMenuTemplate let-column="column" let-filter="filter" let-filterService="filterService">
      <multicheck-filter [isPrimitive]="true" [field]="column.field" [filterService]="filterService"
                         [currentFilter]="filter" [data]="distinctPrimitive(column.field)"></multicheck-filter>
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-column field="requested_by_user" title="Requested By" [width]="150" [style]="vTop">
    <ng-template kendoGridFilterMenuTemplate let-column="column" let-filter="filter" let-filterService="filterService">
      <multicheck-filter [isPrimitive]="true" [field]="column.field" [filterService]="filterService"
                         [currentFilter]="filter" [data]="distinctPrimitive(column.field)"></multicheck-filter>
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-column field="createdAt" title="Requested On" [width]="160" [style]="vTop">
    <ng-template kendoGridCellTemplate let-dataItem>
      {{dataItem.createdAt | date: 'dd/MM/yyyy HH:mm'}}
    </ng-template>
    <ng-template kendoGridFilterMenuTemplate let-column="column" let-filter="filter"
      let-filterService="filterService">
      <multicheck-filter [isPrimitive]="true" [field]="column.field" [filterService]="filterService"
        [currentFilter]="filter" [data]="distinctPrimitive(column.field, true)" [includeTime]="true"></multicheck-filter>
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-column field="user_story_estimate_description" title="Estimate" [width]="100" [style]="vTop">
    <ng-template kendoGridFilterMenuTemplate let-column="column" let-filter="filter" let-filterService="filterService">
      <multicheck-filter [isPrimitive]="true" [field]="column.field" [filterService]="filterService"
                         [currentFilter]="filter" [data]="distinctPrimitive(column.field)"></multicheck-filter>
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-column title="Delete" [width]="80" [style]="vTop">
    <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
      <button [hidden]="!canDestroy || dataItem.user_story_status_description.toLowerCase() === 'deleted'"
              (click)="onConfirmDelete(dataItem)" kendoButton class="btn btn-stn-grid">
        <fa-icon icon="trash"></fa-icon>
      </button>
    </ng-template>
  </kendo-grid-column>

</kendo-grid>
}

@if(dashboard !== dashboardEnums.ICEBOX && dashboard !== dashboardEnums.CURRENT){
<kendo-grid [kendoGridBinding]="gridData" [sort]="sort" [sortable]="true" [groupable]="true" [resizable]="true"
            [filter]="filter" filterable="menu" (filterChange)="filterChange($event)" (sortChange)="sortChange($event)"
            [pageSize]="pageSize" [pageable]="{  buttonCount: buttonCount, pageSizes: pageSizes, previousNext: previousNext}"
            style="height: calc(100vh - 200px); min-height: 400px;">
  <ng-template kendoGridToolbarTemplate position="top">
    <div>
      <h5>
        User Stories
      </h5>
    </div>
    <kendo-grid-spacer></kendo-grid-spacer>
    @if(dashboard === dashboardEnums.COMPLETED){
    <button [hidden]="!canCreate" (click)="onAddClicked(windowTitleBar)" kendoButton class="btn btn-primary">
      <fa-icon icon="circle-plus"></fa-icon> Add User Story
    </button>
    }
  </ng-template>

  <kendo-grid-column title="Edit" [width]="70" [style]="vTop">
    <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
      <button (click)="onEditClick(dataItem, windowTitleBar)" [hidden]="!canUpdate" kendoButton
        class="btn btn-stn-grid">
        <fa-icon icon="edit"></fa-icon>
      </button>
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-column title="History" [width]="80" [style]="vTop">
    <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
      <button (click)="onViewHistoryClick(dataItem, windowTitleBar)" kendoButton class="btn btn-stn-grid">
        <fa-icon icon="timeline"></fa-icon>
      </button>
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-column field="id" title="Id" [width]="140" [style]="vTop">
    <ng-template kendoGridCellTemplate let-dataItem>
      <kendo-buttongroup selection="single">
        <button kendoButton title="Copy this story's link to your clipboard" (click)="copyLink(dataItem)">
          <fa-icon class="fa-solid fa-duotone " [icon]="['fad', 'link']"></fa-icon>
        </button>
        <button kendoButton title="Copy this story's ID to your clipboard" (click)="copyStoryID(dataItem.id)">
          {{dataItem.id}}
        </button>
      </kendo-buttongroup>
    </ng-template>
    <ng-template kendoGridFilterMenuTemplate let-column="column" let-filter="filter" let-filterService="filterService">
      <multicheck-filter [isPrimitive]="true" [field]="column.field" [filterService]="filterService"
        [currentFilter]="filter" [data]="distinctPrimitive(column.field)"></multicheck-filter>
    </ng-template>
  </kendo-grid-column>

  <!-- <kendo-grid-column field="project_name" title="Project Name" [width]="160" [style]="vTop">
    <ng-template kendoGridFilterMenuTemplate let-column="column" let-filter="filter" let-filterService="filterService">
      <multicheck-filter [isPrimitive]="true" [field]="column.field" [filterService]="filterService"
        [currentFilter]="filter" [data]="distinctPrimitive(column.field)"></multicheck-filter>
    </ng-template>
  </kendo-grid-column> -->

  <kendo-grid-column field="title" title="Title" [width]="250" [style]="vTop">
    <ng-template kendoGridCellTemplate let-dataItem>
      <div [innerHTML]="formatText(dataItem.title)"></div>
    </ng-template>
    <ng-template kendoGridFilterMenuTemplate let-column="column" let-filter="filter" let-filterService="filterService">
      <multicheck-filter [isPrimitive]="true" [field]="column.field" [filterService]="filterService"
        [currentFilter]="filter" [data]="distinctPrimitive(column.field)"></multicheck-filter>
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-column field="user_story_priority_description" title="Priority" [width]="120">
    <ng-template kendoGridCellTemplate let-dataItem>
      <div [ngClass]="{'priority-low': dataItem.user_story_priority_description?.toLowerCase().indexOf('low') != -1
        , 'priority-medium': dataItem.user_story_priority_description?.toLowerCase().indexOf('medium') != -1
        , 'priority-high': dataItem.user_story_priority_description?.toLowerCase().indexOf('high') != -1
        , 'priority-critical': dataItem.user_story_priority_description?.toLowerCase().indexOf('critical') != -1 }">
        {{dataItem.user_story_priority_description}}
      </div>
    </ng-template>
    <ng-template kendoGridFilterMenuTemplate let-column="column" let-filter="filter" let-filterService="filterService">
      <multicheck-filter [isPrimitive]="true" [field]="column.field" [filterService]="filterService"
        [currentFilter]="filter" [data]="distinctPrimitive(column.field)"></multicheck-filter>
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-column field="user_story_status_description" title="Status" [width]="120" [style]="vTop">
    <ng-template kendoGridCellTemplate let-dataItem>
      <span
        [ngStyle]="{'color': dataItem.user_story_status_description?.toLowerCase() == 'accepted' ? 'green' :
        dataItem.user_story_status_description?.toLowerCase() == 'rejected' ? 'red' :
        dataItem.user_story_status_description?.toLowerCase() == 'finished' || dataItem.user_story_status_description?.toLowerCase() == 'delivered' ? 'blue' : ''}">
        {{dataItem.user_story_status_description}}
      </span>
    </ng-template>
    <ng-template kendoGridFilterMenuTemplate let-column="column" let-filter="filter" let-filterService="filterService">
      <multicheck-filter [isPrimitive]="true" [field]="column.field" [filterService]="filterService"
        [currentFilter]="filter" [data]="distinctPrimitive(column.field)"></multicheck-filter>
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-column field="user_story_type_description" title="Type" [width]="110" [style]="vTop">
    <ng-template kendoGridFilterMenuTemplate let-column="column" let-filter="filter" let-filterService="filterService">
      <multicheck-filter [isPrimitive]="true" [field]="column.field" [filterService]="filterService"
        [currentFilter]="filter" [data]="distinctPrimitive(column.field)"></multicheck-filter>
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-column field="owned_by_users" title="Owners" [width]="120" [style]="vTop">
    <ng-template kendoGridFilterMenuTemplate let-column="column" let-filter="filter" let-filterService="filterService">
      <multicheck-filter [isPrimitive]="true" [field]="column.field" [filterService]="filterService"
        [currentFilter]="filter" [data]="distinctPrimitive(column.field)"></multicheck-filter>
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-column field="requested_by_user" title="Requested By" [width]="150" [style]="vTop">
    <ng-template kendoGridFilterMenuTemplate let-column="column" let-filter="filter" let-filterService="filterService">
      <multicheck-filter [isPrimitive]="true" [field]="column.field" [filterService]="filterService"
        [currentFilter]="filter" [data]="distinctPrimitive(column.field)"></multicheck-filter>
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-column field="createdAt" title="Requested On" [width]="160" [style]="vTop">
    <ng-template kendoGridCellTemplate let-dataItem>
      {{dataItem.createdAt | date: 'dd/MM/yyyy HH:mm'}}
    </ng-template>
    <ng-template kendoGridFilterMenuTemplate let-column="column" let-filter="filter"
      let-filterService="filterService">
      <multicheck-filter [isPrimitive]="true" [field]="column.field" [filterService]="filterService"
        [currentFilter]="filter" [data]="distinctPrimitive(column.field, true)" [includeTime]="true"></multicheck-filter>
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-column field="user_story_estimate_description" title="Estimate" [width]="100" [style]="vTop">
    <ng-template kendoGridFilterMenuTemplate let-column="column" let-filter="filter" let-filterService="filterService">
      <multicheck-filter [isPrimitive]="true" [field]="column.field" [filterService]="filterService"
        [currentFilter]="filter" [data]="distinctPrimitive(column.field)"></multicheck-filter>
    </ng-template>
  </kendo-grid-column>

  <kendo-grid-column title="Delete" [width]="80" [style]="vTop">
    <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
      <button [hidden]="!canDestroy || dataItem.user_story_status_description.toLowerCase() === 'deleted'"
        (click)="onConfirmDelete(dataItem)" kendoButton class="btn btn-stn-grid">
        <fa-icon icon="trash"></fa-icon>
      </button>
    </ng-template>
  </kendo-grid-column>

</kendo-grid>
}
<div kendoDialogContainer></div>
